<template>
  <main class="gmp-page gmp-page--no-newsletter trace-query-page">
    <div class="container-fluid py-4 px-3 px-md-4">
      <!-- 页面标题 -->
      <div class="row mb-4">
        <div class="col-12">
          <h1 class="text-center mb-3">商品溯源查询</h1>
          <p class="text-center text-muted" v-if="tradeNo">交易单号: {{ tradeNo }}</p>
          <!-- 配送单据信息 -->
          <div v-if="bill" class="card mt-3 mb-3">
            <div class="card-header bg-info text-white">
              <h6 class="mb-0 trace-header-title">
                <i class="fa fa-file-text me-2"></i>配送单据信息
              </h6>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <p><strong>单据编号：</strong>{{ bill.nxDepartmentBillId || '未知' }}</p>
                  <p v-if="bill.nxDbDate"><strong>配送日期：</strong>{{ bill.nxDbDate }} {{ bill.nxDbDay || '' }}</p>
                  <p v-if="bill.nxDbTime"><strong>配送时间：</strong>{{ bill.nxDbTime }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 加载状态 -->
      <div v-if="loading" class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">加载中...</span>
        </div>
        <p class="mt-3">正在查询溯源信息...</p>
      </div>

      <!-- 错误提示 -->
      <div v-if="error" class="alert alert-danger" role="alert">
        <h4 class="alert-heading">查询失败</h4>
        <p>{{ error }}</p>
      </div>

      <!-- 无数据提示 -->
      <div v-if="!loading && !error && (!orders || orders.length === 0)" class="alert alert-info" role="alert">
        <h4 class="alert-heading">暂无数据</h4>
        <p>未找到该交易单号的订单信息</p>
      </div>

      <!-- 订单列表 -->
      <div v-if="!loading && !error && orders && orders.length > 0">
        <div class="row">
          <div class="col-12">
            <div class="card mb-3" v-for="(order, index) in orders" :key="order.nxDepartmentOrdersId || index">
              <!-- 商品信息标题暂时屏蔽 -->
              <!-- <div class="card-header bg-primary text-white">
                <h5 class="mb-0">
                  <i class="fa fa-shopping-cart me-2"></i>
                  商品信息
                </h5>
              </div> -->
              <div class="card-body">
                <div class="row">
                  <!-- 左侧：商品图片（手机端占1/4，桌面端显示） -->
                  <div class="col-3 col-md-4 col-lg-3 mb-3 mb-md-0 goods-image-wrapper">
                    <div v-if="getGoodsImageUrl(order) && !order.imageLoadError" class="goods-image-container">
                      <img 
                        :src="getGoodsImageUrl(order)" 
                        :alt="order.nxDoGoodsName || '商品图片'"
                        class="goods-image"
                        @click="showGoodsImage(order)"
                        @error="handleGoodsImageError($event, order)"
                      />
                      <div class="goods-image-overlay">
                        <i class="fa fa-search-plus"></i>
                      </div>
                    </div>
                    <div v-else class="goods-image-placeholder">
                      <i class="fa fa-camera fa-3x text-muted"></i>
                    </div>
                  </div>

                  <!-- 右侧：商品信息和溯源信息（手机端占3/4） -->
                  <div class="col-9 col-md-8 col-lg-9">
                    <!-- 商品名称和查看溯源报告按钮 -->
                    <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap">
                      <div class="flex-grow-1 me-2 goods-text-container" :style="goodsTextStyle">
                        <p class="mb-0 goods-name-text" :style="goodsTextStyle">
                          <strong class="goods-label" :style="goodsLabelStyle">商品名称：</strong>
                          <span class="goods-value" :style="goodsValueStyle">{{ order.nxDoGoodsName || '未知' }}</span>
                        </p>
                        <p class="mb-0 mt-1 goods-spec-text" :style="goodsTextStyle">
                          <strong class="goods-label" :style="goodsLabelStyle">商品规格：</strong>
                          <span class="goods-value" :style="goodsValueStyle">{{ (order.nxDistributerGoodsEntity && order.nxDistributerGoodsEntity.nxDgGoodsStandardname) || '未知' }}</span>
                        </p>
                      </div>
                      <div v-if="order.nxTraceReportEntity" class="trace-report-action">
                        <button 
                          class="btn btn-link p-0 text-decoration-none text-primary trace-view-btn" 
                          @click="showTraceReport(order)"
                          :style="mobileButtonStyle"
                        >
                          <i 
                            :class="order.nxTraceReportEntity.nxTrReportType === 'image' ? 'fa fa-image' : 'fa fa-file-pdf-o'" 
                            class="trace-icon" 
                            :style="mobileButtonStyle"
                          ></i>
                          <span :style="mobileButtonStyle">查看</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 溯源报告图片预览模态框 -->
    <div v-if="isImageModalVisible" class="image-modal" @click="closeImageModal">
      <div class="image-modal-content" @click.stop>
        <img :src="currentImageUrl" alt="溯源报告图片" class="image-modal-img" @error="handleImageError" />
      </div>
    </div>

    <!-- 商品图片预览模态框 -->
    <div v-if="isGoodsImageModalVisible" class="image-modal" @click="closeGoodsImageModal">
      <div class="image-modal-content" @click.stop>
        <img :src="currentGoodsImageUrl" alt="商品图片" class="image-modal-img" @error="handleGoodsImageModalError" />
      </div>
    </div>
  </main>
</template>

<script>
import { getOrdersByTradeNoWithTraceReport } from '../../network/trace'
import config from '../../../config/index.js'

export default {
  name: 'TraceQuery',
  data() {
    return {
      tradeNo: null,
      bill: null,  // 配送单据信息
      orders: [],
      loading: false,
      error: null,
      isImageModalVisible: false,  // 图片预览模态框显示状态
      currentImageUrl: '',  // 当前预览的图片URL
      isGoodsImageModalVisible: false,  // 商品图片预览模态框
      currentGoodsImageUrl: ''  // 当前预览的商品图片URL
    }
  },
  computed: {
    // 手机端按钮样式（内联样式确保生效）
    mobileButtonStyle() {
      if (typeof window !== 'undefined' && window.innerWidth <= 768) {
        return {
          fontSize: '2.8rem', // 2倍大小（1.4rem * 2）
          fontWeight: '500',
          padding: '0.5rem 0.75rem',
          lineHeight: '1.2'
        }
      }
      return {}
    },
    // 商品信息文字样式
    goodsTextStyle() {
      if (typeof window !== 'undefined' && window.innerWidth <= 768) {
        return {
          fontSize: '2.0rem', // 手机端2.0rem
          lineHeight: '1.5'
        }
      }
      return {
        fontSize: '0.7rem' // 桌面端0.7rem
      }
    },
    // 商品标签样式（灰色）
    goodsLabelStyle() {
      if (typeof window !== 'undefined' && window.innerWidth <= 768) {
        return {
          fontSize: '2.0rem', // 手机端2.0rem
          color: '#6c757d' // 灰色
        }
      }
      return {
        fontSize: '0.7rem', // 桌面端0.7rem
        color: '#6c757d' // 灰色
      }
    },
    // 商品值样式（黑色、粗体）
    goodsValueStyle() {
      if (typeof window !== 'undefined' && window.innerWidth <= 768) {
        return {
          fontSize: '2.0rem', // 手机端2.0rem
          color: '#000000', // 黑色
          fontWeight: 'bold' // 粗体
        }
      }
      return {
        fontSize: '0.7rem', // 桌面端0.7rem
        color: '#000000', // 黑色
        fontWeight: 'bold' // 粗体
      }
    }
  },
  mounted() {
    // 从URL参数获取tradeNo（支持路径参数和查询参数）
    this.tradeNo = this.$route.params.billId || this.$route.params.tradeNo || this.$route.query.billId || this.$route.query.tradeNo
    
    // 如果URL中没有找到tradeNo，尝试从完整URL中提取（处理二维码直接指向后端API的情况）
    if (!this.tradeNo) {
      const fullUrl = window.location.href
      // 尝试从完整URL中提取交易单号，匹配多种模式：
      // 1. getOrdersByTradeNoWithTraceReport/交易单号
      // 2. nxdepartmentorders/getOrdersByTradeNoWithTraceReport/交易单号
      let match = fullUrl.match(/getOrdersByTradeNoWithTraceReport\/([^/?&#]+)/)
      if (match && match[1]) {
        this.tradeNo = decodeURIComponent(match[1])
      } else {
        // 尝试从URL路径的最后一部分提取（可能是交易单号）
        const pathParts = window.location.pathname.split('/').filter(p => p)
        const lastPart = pathParts[pathParts.length - 1]
        // 如果最后一部分看起来像交易单号（不是常见的路径名）
        if (lastPart && !['trace', 'api', 'nxdepartmentorders', 'getOrdersByTradeNoWithTraceReport'].includes(lastPart)) {
          this.tradeNo = decodeURIComponent(lastPart)
        }
      }
    }
    
    if (this.tradeNo) {
      // tradeNo可以是字符串，不需要转换为数字
      // 自动查询
      this.queryTrace()
    } else {
      this.error = '缺少交易单号参数，请检查URL是否正确'
    }
  },
  methods: {
    // 查询溯源信息
    async queryTrace() {
      if (!this.tradeNo) {
        this.error = '交易单号不能为空'
        return
      }

      this.loading = true
      this.error = null
      this.orders = []

      try {
        const response = await getOrdersByTradeNoWithTraceReport(this.tradeNo)
        
        // 根据后端返回的数据结构处理
        // 返回格式: { code: 0, data: { bill: {...}, orders: [...] } }
        if (response.code === 0 && response.data) {
          // 保存配送单据信息
          this.bill = response.data.bill || null
          // 获取订单列表
          this.orders = response.data.orders || []
        } 
        // 兼容其他格式
        else if (response.code === 200 && response.data) {
          // 如果data是数组
          if (Array.isArray(response.data)) {
            this.orders = response.data
          }
          // 如果data是对象，包含orders
          else if (response.data.orders) {
            this.bill = response.data.bill || null
            this.orders = response.data.orders || []
          }
        }
        // 如果后端直接返回数组
        else if (Array.isArray(response)) {
          this.orders = response
        }
        // 如果返回的是 { data: [...] } 格式
        else if (response.data && Array.isArray(response.data)) {
          this.orders = response.data
        }
        else {
          this.orders = []
        }

        if (this.orders.length === 0) {
          this.error = '未找到相关订单信息'
        }
      } catch (err) {
        // console.error('查询溯源信息失败:', err)
        this.error = err.message || '查询失败，请稍后重试'
      } finally {
        this.loading = false
      }
    },
    
    // 格式化日期
    formatDate(dateStr) {
      if (!dateStr) return '未知'
      try {
        const date = new Date(dateStr)
        return date.toLocaleDateString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        })
      } catch (e) {
        return dateStr
      }
    },
    
    // 获取订单状态样式类
    getStatusClass(status) {
      const statusMap = {
        0: 'badge-secondary',
        1: 'badge-success',
        2: 'badge-warning',
        3: 'badge-danger'
      }
      return statusMap[status] || 'badge-secondary'
    },
    
    // 获取订单状态文本
    getStatusText(status) {
      const statusMap = {
        0: '待处理',
        1: '已完成',
        2: '处理中',
        3: '已取消'
      }
      return statusMap[status] || '未知'
    },
    
    // 获取单据状态样式类
    getBillStatusClass(status) {
      const statusMap = {
        0: 'badge-secondary',
        1: 'badge-success',
        2: 'badge-warning',
        3: 'badge-danger'
      }
      return statusMap[status] || 'badge-secondary'
    },
    
    // 获取单据状态文本
    getBillStatusText(status) {
      const statusMap = {
        0: '待处理',
        1: '已完成',
        2: '处理中',
        3: '已取消'
      }
      return statusMap[status] || '未知'
    },
    
    // 打开溯源报告
    showTraceReport(order) {
      if (!order || !order.nxTraceReportEntity) {
        alert('暂无溯源报告')
        return
      }

      const traceReport = order.nxTraceReportEntity
      const reportType = traceReport.nxTrReportType // 'image' 或 'pdf'
      const fileName = traceReport.nxTrFilePath || ''

      if (!fileName) {
        alert('溯源报告文件不存在')
        return
      }

      let filePath = ''
      
      // 判断fileName是否已经是完整URL
      if (fileName.startsWith('http://') || fileName.startsWith('https://')) {
        // 如果已经是完整URL，直接使用
        filePath = fileName
      } else {
        // 如果是相对路径，需要拼接服务器地址
        // 获取服务器地址（从config中获取）
        // 参考微信小程序：serverUrl = apiUrl.server || apiUrl.apiUrl.replace('/api/', '/')
        let serverUrl = config.baseURL || ''
        
        // 处理URL格式：将 /api/ 替换为 /
        if (serverUrl.includes('/api/')) {
          serverUrl = serverUrl.replace('/api/', '/')
        }
        
        // 确保URL以/结尾
        serverUrl = serverUrl.replace(/\/$/, '') + '/'
        
        // 拼接完整文件路径（文件名可能已经包含路径，如 traceReports/xxx.jpg）
        // 如果fileName以/开头，去掉开头的/
        const cleanFileName = fileName.startsWith('/') ? fileName.substring(1) : fileName
        filePath = serverUrl + cleanFileName
      }
      
      // console.log('打开溯源报告:', filePath, '类型:', reportType)

      if (reportType === 'image') {
        // 图片：使用模态框显示，避免跳转到登录页
        this.showImageModal(filePath)
      } else if (reportType === 'pdf') {
        // PDF：在新窗口打开（浏览器会自动处理PDF）
        // 如果跳转到登录页，可以尝试使用iframe
        window.open(filePath, '_blank')
      } else {
        alert('未知的报告类型: ' + reportType)
      }
    },
    
    // 显示图片预览模态框
    showImageModal(imageUrl) {
      this.currentImageUrl = imageUrl
      this.isImageModalVisible = true
    },
    
    // 关闭图片预览
    closeImageModal() {
      this.isImageModalVisible = false
      this.currentImageUrl = ''
    },
    
    // 处理图片加载错误
    handleImageError() {
      // console.error('图片加载失败:', this.currentImageUrl)
      alert('图片加载失败，可能是权限问题或文件不存在')
      this.closeImageModal()
    },
    
    // 获取商品图片URL
    getGoodsImageUrl(order) {
      if (!order || !order.nxDistributerGoodsEntity) {
        return null
      }
      
      const goodsEntity = order.nxDistributerGoodsEntity
      const imageFile = goodsEntity.nxDgGoodsFile || ''
      
      if (!imageFile) {
        return null
      }
      
      // 判断是否已经是完整URL
      if (imageFile.startsWith('http://') || imageFile.startsWith('https://')) {
        return imageFile
      }
      
      // 获取服务器地址，去掉 /api/ 部分
      let serverUrl = config.baseURL || ''
      if (serverUrl.includes('/api/')) {
        serverUrl = serverUrl.replace('/api/', '/')
      }
      // 确保URL以/结尾
      serverUrl = serverUrl.replace(/\/$/, '') + '/'
      
      // 拼接完整URL（图片文件名可能包含路径，如 goodsImage/xxx.jpg）
      const cleanFileName = imageFile.startsWith('/') ? imageFile.substring(1) : imageFile
      return serverUrl + cleanFileName
    },
    
    // 显示商品图片大图
    showGoodsImage(order) {
      if (!order || !order.nxDistributerGoodsEntity) {
        return
      }
      
      const goodsEntity = order.nxDistributerGoodsEntity
      // 优先使用大图，如果没有大图则使用普通图
      const imageFile = goodsEntity.nxDgGoodsFileLarge || goodsEntity.nxDgGoodsFile || ''
      
      if (!imageFile) {
        return
      }
      
      let imageUrl = ''
      
      // 判断是否已经是完整URL
      if (imageFile.startsWith('http://') || imageFile.startsWith('https://')) {
        imageUrl = imageFile
      } else {
        // 获取服务器地址，去掉 /api/ 部分
        let serverUrl = config.baseURL || ''
        if (serverUrl.includes('/api/')) {
          serverUrl = serverUrl.replace('/api/', '/')
        }
        // 确保URL以/结尾
        serverUrl = serverUrl.replace(/\/$/, '') + '/'
        
        // 拼接完整URL（图片文件名可能包含路径，如 goodsImage/xxx.jpg）
        const cleanFileName = imageFile.startsWith('/') ? imageFile.substring(1) : imageFile
        imageUrl = serverUrl + cleanFileName
      }
      
      this.currentGoodsImageUrl = imageUrl
      this.isGoodsImageModalVisible = true
    },
    
    // 关闭商品图片预览
    closeGoodsImageModal() {
      this.isGoodsImageModalVisible = false
      this.currentGoodsImageUrl = ''
    },
    
    // 处理商品图片加载错误
    handleGoodsImageError(event, order) {
      // 标记图片加载失败，触发Vue响应式更新显示占位符
      if (order) {
        this.$set(order, 'imageLoadError', true)
      }
    },
    
    // 处理商品图片模态框加载错误
    handleGoodsImageModalError() {
      alert('商品图片加载失败')
      this.closeGoodsImageModal()
    }
  }
}
</script>

<style lang="less" scoped>
.trace-query-page {
  min-height: 100vh;
  padding-top: 20px; // 不需要为导航栏留空间
  
  // 主要内容左右边距（手机端）
  .container-fluid {
    @media (max-width: 768px) {
      padding-left: 15px;
      padding-right: 15px;
    }
  }
  
  h1 {
    color: #1a73e8;
    font-weight: 500;
    font-size: 2.5rem; // 桌面端增大
    // 手机端字体大小
    @media (max-width: 768px) {
      font-size: 2.5rem; // 手机端增大到2.5rem
    }
  }
  
  // 配送单据信息标题字体大小适配
  .trace-header-title {
    font-size: 1rem; // 默认大小
    
    @media (max-width: 768px) {
      font-size: 2.0rem; // 手机端增大到2.0rem
    }
    
    @media (max-width: 576px) {
      font-size: 2.0rem; // 小屏幕也保持2.0rem
    }
  }
  
  .card {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border: none;
    margin-bottom: 20px;
    
    // 手机端卡片左右边距
    @media (max-width: 768px) {
      margin-left: 0;
      margin-right: 0;
    }
    
    .card-header {
      border-bottom: 2px solid rgba(255, 255, 255, 0.2);
      
      // 手机端标题字体
      h5, h6 {
        @media (max-width: 768px) {
          font-size: 1.5rem; // 手机端增大到1.5rem
        }
      }
    }
    
    .card-body {
      // 手机端内容字体
      @media (max-width: 768px) {
        font-size: 2.0rem; // 手机端增大到2.0rem
        padding: 1rem;
        
        p {
          font-size: 2.0rem !important; // 手机端增大到2.0rem
          margin-bottom: 0.75rem;
          
          strong {
            font-size: 2.0rem !important; // 手机端增大到2.0rem
          }
        }
      }
    }
  }
  
  // 商品图片包装器（确保手机端显示）
  .goods-image-wrapper {
    display: block !important; // 强制显示
    
    @media (max-width: 768px) {
      display: block !important;
      padding-right: 0.5rem; // 手机端右侧间距
      margin-bottom: 0 !important; // 手机端不需要底部间距
    }
  }
  
  // 商品图片容器
  .goods-image-container {
    position: relative;
    width: 100%;
    max-width: 200px;
    margin: 0 auto;
    cursor: pointer;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    // transition: transform 0.3s, box-shadow 0.3s; // 移除动画效果
    display: block !important; // 强制显示
    aspect-ratio: 1; // 保持正方形（高度=宽度）
    
    // 手机端图片大小调整（适配2列布局）
    @media (max-width: 768px) {
      max-width: 100%;
      width: 100%;
      margin: 0;
      aspect-ratio: 1; // 手机端也保持正方形
    }
    
    @media (max-width: 576px) {
      max-width: 100%;
      width: 100%;
      aspect-ratio: 1; // 小屏也保持正方形
    }
    
    // 移除hover和active动画效果
    // &:hover {
    //   transform: scale(1.05);
    //   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    //   
    //   .goods-image-overlay {
    //     opacity: 1;
    //   }
    // }
    
    // 手机端触摸反馈
    // @media (max-width: 768px) {
    //   &:active {
    //     transform: scale(0.98);
    //   }
    // }
    
    .goods-image {
      width: 100%;
      height: 100%; // 高度填满容器
      display: block !important; // 强制显示
      object-fit: cover; // 保持比例，填充容器
    }
    
    .goods-image-overlay {
      display: none; // 隐藏overlay，因为不需要hover效果
    }
  }
  
  .goods-image-placeholder {
    width: 100%;
    max-width: 200px;
    margin: 0 auto;
    display: flex !important; // 强制显示
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #f8f9fa;
    border: 2px dashed #dee2e6;
    border-radius: 8px;
    color: #6c757d;
    aspect-ratio: 1; // 保持正方形（高度=宽度）
    
    // 手机端占位符适配2列布局
    @media (max-width: 768px) {
      max-width: 100%;
      width: 100%;
      margin: 0;
      aspect-ratio: 1; // 手机端也保持正方形
    }
    
    @media (max-width: 576px) {
      max-width: 100%;
      width: 100%;
      aspect-ratio: 1; // 小屏也保持正方形
    }
    
    i {
      @media (max-width: 768px) {
        font-size: 2.5rem !important; // 手机端图标更大
      }
    }
    
    p {
      @media (max-width: 768px) {
        font-size: 0.85rem !important;
      }
    }
  }
  
  // 商品信息区域
  .goods-info-section {
    h6 {
      font-size: 1rem;
      font-weight: 600;
      
      @media (max-width: 768px) {
        font-size: 1.5rem; // 手机端增大到1.5rem
        margin-bottom: 0.5rem;
      }
    }
    
    // 手机端商品信息间距（2列布局）
    @media (max-width: 768px) {
      margin-bottom: 0.75rem !important;
      padding-left: 0.5rem; // 左侧间距
      
      p {
        margin-bottom: 0.5rem;
        word-break: break-word; // 长文本自动换行
        font-size: 1.4rem; // 手机端增大到1.4rem
        line-height: 1.5;
      }
    }
  }
  
  // 溯源信息区域
  .trace-info-section {
    h6 {
      font-size: 1rem;
      font-weight: 600;
      
      @media (max-width: 768px) {
        font-size: 1rem; // 手机端增大到1rem
        margin-bottom: 0.5rem;
      }
    }
    
    // 查看按钮字体增大（使用深度选择器确保生效）
    /deep/ .trace-view-btn,
    ::v-deep .trace-view-btn,
    .trace-query-page .trace-view-btn,
    .trace-report-action .trace-view-btn {
      @media (max-width: 768px) {
        font-size: 4.2rem !important; // 手机端字体增大3倍
        font-weight: 500 !important;
        padding: 1rem 1.5rem !important;
        line-height: 1.2 !important;
        white-space: nowrap !important;
        display: inline-block !important;
        
        // 覆盖所有可能的 Bootstrap 类
        &.btn-sm,
        &.btn,
        &.btn-link {
          font-size: 4.2rem !important;
          padding: 1rem 1.5rem !important;
        }
        
        // 按钮内的所有元素
        &,
        & *,
        &::before,
        &::after {
          font-size: 4.2rem !important;
        }
        
        // 图标 - 使用多个选择器确保覆盖
        i,
        i.fa,
        i[class*="fa-"],
        .fa,
        .fa-file-text-o {
          font-size: 4.2rem !important;
          margin-right: 0.5rem !important;
          line-height: 1 !important;
        }
        
        // 徽章
        .badge,
        span.badge,
        .badge.bg-light,
        span[class*="badge"] {
          font-size: 3rem !important;
          padding: 0.5em 0.75em !important;
          margin-left: 0.5rem !important;
          line-height: 1.2 !important;
          display: inline-block !important;
        }
      }
      
      @media (max-width: 576px) {
        font-size: 3.9rem !important; // 小屏字体
        padding: 0.9rem 1.3rem !important;
        
        &.btn-sm,
        &.btn,
        &.btn-link {
          font-size: 3.9rem !important;
          padding: 0.9rem 1.3rem !important;
        }
        
        &,
        & * {
          font-size: 3.9rem !important;
        }
        
        i,
        i.fa,
        i[class*="fa-"],
        .fa,
        .fa-file-text-o {
          font-size: 3.9rem !important;
        }
        
        .badge,
        span.badge,
        .badge.bg-light,
        span[class*="badge"] {
          font-size: 2.8rem !important;
        }
      }
    }
    
    // 查看按钮图标样式（控制图标和文字间距）
    .trace-icon {
      margin-right: 0.3rem !important; // 减小图标和文字之间的间距
      display: inline-block;
    }
    
    // 确保按钮内元素紧密排列
    .trace-view-btn {
      display: inline-flex !important;
      align-items: center !important;
      gap: 0.3rem !important; // 使用gap控制间距
    }
    
    // 商品文字容器样式（手机端2倍字体）
    .goods-text-container,
    .goods-text-container p,
    .goods-text-container span,
    .goods-name-text,
    .goods-name-text span,
    .goods-spec-text,
    .goods-spec-text span {
      font-size: 0.7rem; // 桌面端0.7rem
      
      @media (max-width: 768px) {
        font-size: 2.0rem !important; // 手机端2.0rem
        line-height: 1.5 !important;
      }
    }
    
    // 商品标签（"商品名称："、"商品规格："）用灰色 - 使用更强的选择器
    .goods-label,
    strong.goods-label,
    .goods-text-container strong.goods-label,
    .goods-name-text strong.goods-label,
    .goods-spec-text strong.goods-label,
    .trace-query-page .goods-label,
    .trace-query-page strong.goods-label {
      color: #6c757d !important; // 灰色
      
      font-size: 0.7rem; // 桌面端0.7rem
      
      @media (max-width: 768px) {
        font-size: 2.0rem !important; // 手机端2.0rem
        color: #6c757d !important; // 灰色
      }
    }
    
    // 商品值（真正的商品名称和规格值）用黑色、粗体 - 使用更强的选择器
    .goods-value,
    span.goods-value,
    .goods-text-container span.goods-value,
    .goods-name-text span.goods-value,
    .goods-spec-text span.goods-value,
    .trace-query-page .goods-value,
    .trace-query-page span.goods-value {
      color: #000000 !important; // 黑色
      font-weight: bold !important; // 粗体
      
      font-size: 0.7rem; // 桌面端0.7rem
      
      @media (max-width: 768px) {
        font-size: 2.0rem !important; // 手机端2.0rem
        color: #000000 !important; // 黑色
        font-weight: bold !important; // 粗体
      }
    }
    
    // 覆盖全局strong样式
    .goods-text-container strong.goods-label {
      color: #6c757d !important;
    }
    
    .goods-text-container span.goods-value {
      color: #000000 !important;
    }
    
    // 商品名称和按钮的布局
    .d-flex.justify-content-between {
      @media (max-width: 576px) {
        flex-direction: column; // 小屏手机上下排列
        align-items: flex-start !important;
        
        .trace-report-action {
          width: 100%;
          margin-top: 0.5rem;
          
          .btn {
            width: 100%;
          }
        }
      }
    }
    
    .trace-details {
      @media (max-width: 768px) {
        padding: 0.75rem !important;
        font-size: 0.95rem; // 手机端增大到0.95rem
        
        .trace-detail-item {
          font-size: 0.95rem !important; // 覆盖small类，手机端增大
          
          strong {
            display: block;
            margin-bottom: 0.25rem;
            font-size: 0.95rem !important; // 手机端增大
          }
          
          span {
            font-size: 0.95rem !important; // 手机端增大
          }
        }
        
        p {
          margin-bottom: 0.5rem;
          word-break: break-word; // 长文本自动换行
          font-size: 0.95rem; // 手机端增大
          
          strong {
            display: block;
            margin-bottom: 0.25rem;
            font-size: 0.95rem; // 手机端增大
          }
        }
      }
      
      @media (max-width: 576px) {
        padding: 0.5rem !important;
        font-size: 0.9rem; // 小屏也增大
      }
    }
  }
  
  .trace-report-section {
    background-color: #f8f9fa;
    padding: 15px;
    border-radius: 5px;
    margin-top: 15px;
  }
  
  .spinner-border {
    width: 3rem;
    height: 3rem;
  }
  
  .badge {
    padding: 0.35em 0.65em;
    font-size: 0.875em;
  }
  
  p {
    margin-bottom: 0.5rem;
    line-height: 1.6;
    
    // 手机端字体大小
    @media (max-width: 768px) {
      font-size: 1.4rem; // 手机端增大到1.4rem
      margin-bottom: 0.4rem;
    }
  }
  
  strong {
    color: #333;
    margin-right: 5px;
    
    // 手机端字体大小
    @media (max-width: 768px) {
      font-size: 1.4rem; // 手机端增大到1.4rem
    }
  }
  
    // 手机端整体内容区域（2列布局）
    @media (max-width: 768px) {
      .row {
        margin-left: -5px;
        margin-right: -5px;
        
        [class*="col-"] {
          padding-left: 5px;
          padding-right: 5px;
        }
      }
      
      // 卡片在手机端的优化（2列布局）
      .card {
        .card-body {
          padding: 0.75rem;
          
          .row {
            // 手机端2列布局，不需要额外间距
            > div:first-child {
              margin-bottom: 0;
            }
          }
        }
      }
      
      // 按钮在手机端更容易点击
      .btn {
        min-height: 44px; // iOS推荐的最小触摸目标
        touch-action: manipulation; // 优化触摸响应
      }
    }
}

/* 图片预览模态框样式 */
.image-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.image-modal-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
}


.image-modal-img {
  max-width: 100%;
  max-height: 90vh;
  object-fit: contain;
  border-radius: 5px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
}
</style>

